<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.03901 4.46521L10.2165 12.725L4 19.4406H5.39908L10.8416 13.561L15.239 19.4406H20.0001L13.4751 10.7162L19.2613 4.46521H17.8622L12.8499 9.88021L8.80012 4.46521H4.03901ZM6.09645 5.49577H8.28372L17.9423 18.4099H15.755L6.09645 5.49577Z"
        />
    </svg>
</template>
